import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';

export const httpconfigInterceptor: HttpInterceptorFn = (req, next) => {
  const cloned = req.clone({
    setHeaders: {
      'Content-type': 'application/json',
      'apiKey': environment.API_KEY_CORP
    }
  });
  return next(cloned);
};
